import { registerBlockType } from '@wordpress/blocks'
import { Button, PanelBody, Path, Rect, SVG } from '@wordpress/components'
import { InspectorControls, MediaUpload, RichText } from '@wordpress/block-editor'
import { Fragment } from '@wordpress/element'

registerBlockType('usna1978/company-photo-box', {
  title: 'Company Photo Box',
  description: 'Creates and displays the images for the companies.',
  // eslint-disable-next-line react/jsx-pascal-case
  icon: <SVG viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'><Path d='M0,0h24v24H0V0z' fill='none' /><Path d='M20,4H4C2.9,4,2,4.9,2,6v12c0,1.1,0.9,2,2,2h16c1.1,0,2-0.9,2-2V6C22,4.9,21.1,4,20,4z M20,18H4V6h16V18z' /><Rect x='6' y='10' width='2' height='2' /><Rect x='6' y='14' width='8' height='2' /><Rect x='16' y='14' width='2' height='2' /><Rect x='10' y='10' width='8' height='2' /></SVG>,
  category: 'formatting',
  attributes: {
    companyLeader: {
      type: 'string',
      source: 'attribute',
      selector: 'a.captainPhotoImage',
      attribute: 'href'
    },
    companyName: {
      type: 'string',
      source: 'html',
      selector: 'p'
    },
    companyPhoto: {
      type: 'string',
      source: 'attribute',
      selector: 'a.companyPhotoImage',
      attribute: 'href'
    }
  },

  /**
   * The edit function describes the structure of your block in the context of
   * the editor. This represents what the editor will render when the block is
   * used.
   *
   * The "edit" property must be a valid function.
   *
   * @link https://developer.wordpress.org/block-editor/reference-guides/block-api/block-edit-save/
   */
  edit ({ attributes, setAttributes }) {
    const { companyLeader, companyName, companyPhoto } = attributes

    return (
      <Fragment>
        <InspectorControls>
          <PanelBody>
            <MediaUpload
              onSelect={companyLeader => setAttributes({ companyLeader: companyLeader.url })}
              value={companyLeader}
              render={(handleObj) => (
                <Button className='button button-large' onClick={handleObj.open}>
                  {(!companyLeader ? 'Upload/Select Captain Photo' : 'Change Captain Photo')}
                </Button>
              )}
            />
            <MediaUpload
              onSelect={companyPhoto => setAttributes({ companyPhoto: companyPhoto.url })}
              value={companyPhoto}
              render={(handleObj) => (
                <Button className='button button-large' onClick={handleObj.open}>
                  {(!companyPhoto ? 'Upload/Select Company Photo' : 'Change Company Photo')}
                </Button>
              )}
            />
          </PanelBody>
        </InspectorControls>
        <div className='company'>
          <RichText
            className='company-name'
            tagName='p'
            value={companyName}
            placeholder='Enter a company name here...'
            onChange={companyName => setAttributes({ companyName })}
          />
          <div className='company-photos'>
            <div className='captain-photo'>
              {(() => {
                if (companyLeader) {
                  return <img src={companyLeader} alt='Company Captain' />
                }
                return 'Company Captain Photo'
              })()}
            </div>
            <div className='company-photo'>
              {(() => {
                if (companyPhoto) {
                  return <img src={companyPhoto} alt='Company Photo' />
                }
                return 'Company Photo'
              })()}
            </div>
          </div>
        </div>
      </Fragment>
    )
  },

  /**
   * The save function defines the way in which the different attributes should
   * be combined into the final markup, which is then serialized by Gutenberg
   * into post_content.
   *
   * The "save" property must be specified and must be a valid function.
   *
   * @link https://developer.wordpress.org/block-editor/reference-guides/block-api/block-edit-save/
   */
  save ({ attributes }) {
    const { companyLeader, companyName, companyPhoto } = attributes

    return (
      <div className='company'>
        <RichText.Content
          className='company-name'
          tagName='p'
          value={companyName}
        />
        <div className='company-photos'>
          <div className='captain-photo'>
            <a data-fancybox='gallery' className='captainPhotoImage' href={companyLeader}>
              {(() => {
                if (companyLeader) {
                  return <img src={companyLeader} alt='Company Captain' />
                }
                return ''
              })()}
            </a>
          </div>
          <div className='company-photo'>
            <a data-fancybox='gallery' className='companyPhotoImage' href={companyPhoto}>
              {(() => {
                if (companyPhoto) {
                  return <img src={companyPhoto} alt='Company Photo' />
                }
                return ''
              })()}
            </a>
          </div>
        </div>
      </div>
    )
  }
})
